// Generate a unique id (unique within the entire client session).
// Useful for temporary DOM ids.
// Generate a unique id (unique within the entire client session).
export var uniqueId = (function () {
    var idCounter = 0;
    return function (prefix) {
        if (prefix === void 0) { prefix = 'uid'; }
        return "card_" + prefix + "_" + ++idCounter;
    };
}());
//# sourceMappingURL=util.js.map